import React, { useEffect, useState } from 'react';
import './Intro.scss';

import PosterImage from '../../assets/img/intro/featured-video-poster.jpg';
import PosterImageAVIF from '../../assets/img/intro/featured-video-poster.avif';
import PosterImageWEBP from '../../assets/img/intro/featured-video-poster.webp';
import TextImage from '../../assets/img/intro/text-image.png';
import TextImageAVIF from '../../assets/img/intro/text-image.avif';
import TextImageWEBP from '../../assets/img/intro/text-image.webp';

/** @var string */
const FEATURED_VIDEO_ID = 'hXJpMvBOork';

/**
 * `loop` só funciona junto com `playlist`. O resto é para o vídeo ficar
 * decorativo: sem controles, sem teclado, sem anotações e sem tela cheia.
 *
 * `cc_load_policy=0` impede a legenda automática de entrar — sem ele o embed
 * segue a preferência de legenda de quem está assistindo.
 *
 * @var string
 */
const featuredVideoUrl =
  `https://www.youtube.com/embed/${FEATURED_VIDEO_ID}` +
  `?autoplay=1&mute=1&loop=1&playlist=${FEATURED_VIDEO_ID}` +
  '&controls=0&disablekb=1&fs=0&modestbranding=1&rel=0&iv_load_policy=3' +
  '&cc_load_policy=0&playsinline=1';

const Intro = () => {
  /** @var boolean */
  const [videoIsReady, setVideoReadyState] = useState(false);

  /**
   * O player do YouTube é pesado e o vídeo aqui é decorativo, então ele só entra
   * depois que o resto da página terminou de carregar — mesma regra do
   * lazy-load do projeto. Até lá quem aparece é o poster.
   */
  useEffect(() => {
    if (document.readyState === 'complete') {
      setVideoReadyState(true);
      return;
    }

    const onLoad = () => setVideoReadyState(true);

    window.addEventListener('load', onLoad);

    return () => window.removeEventListener('load', onLoad);
  }, []);

  // render
  return (
    <section className="section-intro">
      <div className="container">
        <div className="featured-video">
          <picture className="poster">
            <source srcset={PosterImageAVIF} type="image/avif" />
            <source srcset={PosterImageWEBP} type="image/webp" />
            <img src={PosterImage} alt="Mirrage Nautic Club" />
          </picture>

          {videoIsReady &&
            <div className="frame">
              <iframe
                src={featuredVideoUrl}
                title="Mirrage Nautic Club | Yoga Experience"
                allow="autoplay; encrypted-media"
                loading="lazy"
              ></iframe>
            </div>
          }
        </div>

        <div className="content">
          <div className="title">
            <div className="top">
              Seu<br /> Lifestyle<br /> Náutico<br />
            </div>
            <picture>
              <source srcset={TextImageAVIF} type="image/avif" />
              <source srcset={TextImageWEBP} type="image/webp" />
              <img src={TextImage} alt="Mirrage" className="el-img"/>
            </picture>
            <div className="bottom">
              Aqui
            </div>
          </div>

          <div className="text">
            <p>Um verdadeiro recanto intocado de natureza, beleza e lazer que a Lotus Empreendimentos traz com exclusividade para a vida da sua família. Seja para compartilhar a tranquilidade das águas, seja para viver a intensidade dos esportes náuticos, o Mirrage Nautic Club é perfeito para escapar da urbanidade sem perder a conveniência.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
